export const HAS_ERROR_FIELD_STYLE = {
    border: 'solid 1px',
    borderColor: 'error.main',
    backgroundColor: 'error.light',
    borderRadius: '4px'
};

export const DEFAULT_FIELD_STYLE = {
    backgroundColor: 'background.paper',
    borderRadius: '4px'
};

const DEFAULT_AUTOCOMPLETE_STYLE = {
    color: 'text.secondary'
};

export const editDrawerTextFieldStyles = (hasError = false) => hasError ? HAS_ERROR_FIELD_STYLE : DEFAULT_FIELD_STYLE;
export const editDrawerAutocompleteStyles = (hasError = false) => hasError ? HAS_ERROR_FIELD_STYLE : DEFAULT_AUTOCOMPLETE_STYLE;
